<template>
    <router-view></router-view>
</template>
<script>
export default {
    data() {
        return {};
    },
    computed: {},
    methods: {},
    created() {},
};
</script>
<style lang="scss">
</style>